// src/pages/WaitlistPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function WaitlistPage({ language = 'en' }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', email: '', consent: false });
  const [submitted, setSubmitted] = useState(false);

  const labels = {
    en: {
      title: 'Join the Waitlist',
      subtitle:
        'Be part of a community that’s reimagining how lost things find their way home. Join our waitlist and get early access to YourLostAndFound when it launches in early 2026.',
      name: 'Full Name',
      email: 'Email Address',
      consent: 'I agree to receive news and updates from YourLostAndFound.',
      disclaimer:
        'Your information will only be used to send project updates. You can unsubscribe anytime.',
      submit: 'Join Now',
      back: 'Back',
      success: 'Thank you! You’ve been added to our waitlist.'
    },
    es: {
      title: 'Únete a la lista de espera',
      subtitle:
        'Sé parte de una comunidad que está reinventando la forma en que los objetos perdidos regresan a casa. Únete a la lista de espera y obtén acceso anticipado a YourLostAndFound cuando lancemos en 2026.',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      consent: 'Acepto recibir noticias y actualizaciones de YourLostAndFound.',
      disclaimer:
        'Tu información será utilizada únicamente para enviarte actualizaciones. Puedes darte de baja en cualquier momento.',
      submit: 'Unirme ahora',
      back: 'Volver',
      success: '¡Gracias! Has sido añadido a nuestra lista de espera.'
    },
    pt: {
      title: 'Entre na lista de espera',
      subtitle:
        'Faça parte de uma comunidade que está reinventando a forma como os objetos perdidos voltam para casa. Entre na lista de espera e tenha acesso antecipado ao YourLostAndFound quando lançarmos em 2026.',
      name: 'Nome completo',
      email: 'Email',
      consent: 'Concordo em receber novidades e atualizações da YourLostAndFound.',
      disclaimer:
        'Suas informações serão usadas apenas para enviar atualizações. Você pode cancelar a qualquer momento.',
      submit: 'Participar agora',
      back: 'Voltar',
      success: 'Obrigado! Você entrou na nossa lista de espera.'
    }
  };

  const t = labels[language];

  const encode = (data) =>
  Object.keys(data)
    .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  const formDataToSend = {
    "form-name": "waitlist",
    name: formData.name,
    email: formData.email,
    consent: formData.consent ? "yes" : "no",
  };
  try {
    await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode(formDataToSend),
    });
    setSubmitted(true);
  } catch (err) {
    console.error("Netlify form error:", err);
    alert("There was a problem joining the waitlist. Please try again.");
  }
};

  return (
    <>
      <section id="waitlist" className="bg-[#48887B] py-12 text-center scroll-mt-[120px] pt-[120px]">
        <h2 className="text-white text-3xl md:text-5xl font-bold">{t.title}</h2>
        <p className="text-white/90 text-lg max-w-2xl mx-auto mt-4 px-4">{t.subtitle}</p>
      </section>

      <div className="max-w-3xl mx-auto py-12 px-6">
        {submitted ? (
          <p className="text-green-600 font-semibold mb-6">{t.success}</p>
        ) : (
          <form
            name="waitlist"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
            className="space-y-6"
          >
            {/* Campo oculto obligatorio para Netlify */}
            <input type="hidden" name="form-name" value="waitlist" />

            <div>
              <label className="block mb-1 font-medium" htmlFor="name">{t.name}</label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-lg"
              />
            </div>

            <div>
              <label className="block mb-1 font-medium" htmlFor="email">{t.email}</label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 px-4 py-2 rounded-lg"
              />
            </div>

            <div className="flex items-start space-x-2">
              <input
                type="checkbox"
                id="consent"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
                required
              />
              <label htmlFor="consent" className="text-sm">{t.consent}</label>
            </div>

            <p className="text-xs text-gray-500">{t.disclaimer}</p>

            <button
              type="submit"
              className="px-6 py-2 bg-[#48887B] text-white rounded-lg hover:bg-[#3b726a] transition"
            >
              {t.submit}
            </button>
          </form>
        )}
        <button
          onClick={() => navigate('/')}
          className="mt-6 block px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
        >
          {t.back}
        </button>
      </div>
    </>
  );
}
